import { createContext, useState } from 'react';
import api from 'services/api';

export const OrdensContext = createContext();

export const OrdensProvider = ({ children }) => {
  const [ordens, setOrdens] = useState({
    data: [],
    colunas: [],
    order: { field: 'przent', sort: 'asc' },
    filter: {},
    page: 0,
    size: 10,
  });
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const getOrdens = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: ordens?.filter,
        page: ordens?.page,
        size: ordens?.size,
        order: ordens?.order,
        ...payload,
      });
      setOrdens((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getMateriais = async ({ data, cb }) => {
    try {
      setGetLoading(true);
      const { data: res } = await api.post('/Producao/Ordens/Materiais', data);
      if (cb) {
        cb(res);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getProcessos = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Producao/Processos`, { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getApontamentos = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Producao/Apontamentos`, { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getNecessidade = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Producao/Ordens/Reposicao', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postApontamento = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      const res = await api.post(`/Producao/Apontamento`, data);
      if (cb) {
        cb(res?.data);
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postRequisitarRegistrar = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post(`/Producao/Ordens/RequisitarRegistrar`, data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postCalculo = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post(`/Producao/Ordens/Calculo`, data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getMapa = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Producao/Mapa`, { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <OrdensContext.Provider
      value={{
        ordens,
        getLoading,
        postLoading,
        getOrdens,
        getMateriais,
        getNecessidade,
        getProcessos,
        getApontamentos,
        postApontamento,
        postRequisitarRegistrar,
        postCalculo,
        getMapa,
      }}
    >
      {children}
    </OrdensContext.Provider>
  );
};
